/**
 * Service for opening print preview with list of classroom codes for a school.
 */
angular.module('charts')
  .service('dblClassroomCodePrintService', [
    '$compile',
    '$rootScope',
    '$timeout',
    'dblPrintService',
    '$state',
    function(
      $compile,
      $rootScope,
      $timeout,
      dblPrintService,
      $state
    ) {

      /**
       * Open browser's print preview window with a table of classroom codes for a school.
       *
       * @param districtId District for school
       * @param schoolId ID of school
       */
      this.printClassroomCodesForSchool = function (districtId, schoolId) {
        // Hold the compiled element to print
        var element;

        var scope = $rootScope.$new();
        scope.districtId = districtId;
        scope.schoolId = schoolId;

        // This function gets called when the edxClassroomCodeReport finishes loading data
        scope.onReady = function() {
          // Open the print preview within a timeout so that the in progress digest can complete before
          // the browser takes a snapshot of the rendered HTML.
          $timeout(function(){dblPrintService.printElement(element);}, 150);

          // For debugging the printed report it can be helpful to render it on the screen
          // For that the above print call can be commented out and this line uncomment so that the contents get
          // appended to the page instead of opened in the print preview which can't be inspected.
          // angular.element('div[ui-view=rightPane]').after(e);
        };

        // Compile the HTML element to print
        element = $compile("<edx-classroom-code-report " +
          "dbl-district-id='districtId' " +
          "dbl-school-id='schoolId' " +
          "dbl-on-ready='onReady()'" +
          "></edx-classroom-code-report>")(scope);
      };

      this.newPrintClassroomCodesForSchool = function(districtId, schoolId){
        // in the new angular this is needed because there's no district_id in the state in the new angular so we add it here
        if(!$state.params.districtId){
          $state.params = angular.merge($state.params, {districtId: districtId});
        }
        this.printClassroomCodesForSchool(districtId, schoolId);
      };

    }]);
